import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiPhone } from 'react-icons/fi';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { useSiteSettings } from '../../context/SiteSettingsContext';

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation();
  const { settings } = useSiteSettings();
  return (
    <section className="py-20 lg:py-32 bg-[#1e3a8a] relative overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle, #ffffff 1px, transparent 1px)", backgroundSize: "36px 36px" }} />
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-white/20" />

      <div className="relative max-w-4xl mx-auto px-8 sm:px-12 lg:px-16 text-center">
        <motion.div ref={ref} initial={{ opacity: 0, y: 30 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}>
          <div className="inline-block px-5 py-2 bg-white/15 border border-white/25 text-white font-semibold text-xs uppercase tracking-[0.25em] rounded-full mb-8">
            Join Our School Family
          </div>
          <h2 className="text-4xl sm:text-6xl font-bold text-white mb-6 leading-tight">
            Enroll Your <span className="text-sky-300">Child Today</span>
          </h2>
          <p className="text-blue-100/80 text-lg sm:text-xl font-medium mb-4 max-w-2xl mx-auto leading-relaxed">
            Give your child the best start in life with {settings?.schoolName || "Hillbert English Boarding School "}'s
            world-class education. Admissions are now open for the 2025–2026 academic year.
          </p>
          <p className="text-sky-300 font-semibold text-sm mb-12 uppercase tracking-widest">
            Limited seats available. Early applications are encouraged.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/admissions/apply"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-[#1D4ED8] font-bold uppercase tracking-wide text-sm hover:bg-blue-50 transition-all rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-0.5">
              Apply Now <FiArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/contact"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/15 border-2 border-white/40 text-white font-bold uppercase tracking-wide text-sm hover:bg-white hover:text-[#1D4ED8] transition-all rounded-xl hover:-translate-y-0.5">
              <FiPhone className="w-4 h-4" /> Contact Us
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
